var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#D4D4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6267 9.33327C10.6265 9.68689 10.4859 10.026 10.2357 10.2759C9.98552 10.5258 9.64631 10.6661 9.29269 10.6659C8.93907 10.6658 8.6 10.5251 8.35007 10.2749C8.10015 10.0248 7.95985 9.68556 7.96002 9.33193C7.9602 8.97831 8.10084 8.63924 8.35102 8.38932C8.60119 8.1394 8.9404 7.99909 9.29402 7.99927C9.64764 7.99944 9.98671 8.14009 10.2366 8.39026C10.4866 8.64044 10.6269 8.97965 10.6267 9.33327ZM10.6667 11.6533H8.00002V19.9999H10.6667V11.6533ZM14.88 11.6533H12.2267V19.9999H14.8534V15.6199C14.8534 13.1799 18.0334 12.9533 18.0334 15.6199V19.9999H20.6667V14.7133C20.6667 10.5999 15.96 10.7533 14.8534 12.7733L14.88 11.6533Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2b644f09230653d9f6a3b6e79f651880.svg";
export { ForwardRef as ReactComponent };